// extracted by mini-css-extract-plugin
export default {"box":"BlockUser_box__mZFL8","selectTitle":"BlockUser_selectTitle__Xjvdr","title":"BlockUser_title__Dr7SN","inputTitle":"BlockUser_inputTitle__JDnET"};